import React from 'react';
import renderHTML from 'react-render-html';

const Commitment = ({ header, imgSrc1, alt1, title1, content1, imgSrc2, alt2, title2, content2,  imgSrc3, alt3, title3, content3, imgSrc4, alt4, title4, content4 }) => 
	{
		return (
			<section className="row commitment">
				<div className="col sm-12">
					<h2 className="title">{ header }</h2>
				</div>
				<div className="callouts">
					<div className="col sm-2">
						<img className="icon" src={ imgSrc1 } alt={ alt1 } />
						<h3 className="sub-title">{ renderHTML( title1 ) }</h3>
						<p>{ renderHTML( content1 ) }</p>
					</div>
					<div className="col sm-2">
						<img className="icon" src={ imgSrc2 } alt={ alt2 }/>
						<h3 className="sub-title">{ renderHTML( title2 ) }</h3>
						<p>{ renderHTML( content2 ) }</p>
					</div>
					<div className="col sm-2">
						<img className="icon" src={ imgSrc3 } alt={ alt3 } />
						<h3 className="sub-title">{ renderHTML( title3 ) }</h3>
						<p>{ renderHTML( content3 ) }</p>
					</div>
				</div>
			</section>
		);
	}

export default Commitment;


// WEBPACK FOOTER //
// ./src/pages/category/common/Commitment.js